import React from "react";
import {twMerge} from "tailwind-merge";

export default function SlideoutPanel(props: {
    children: React.ReactNode;
    isOpen: boolean;
    className?: string;
    backdropClassName?: string;
    noBackdrop?: boolean;
    // fired when the user clicks the background overlay
    shouldClose?: () => void;
}) {
    const backdropClasses = twMerge(
        // standard classes. inset-0 already fills the viewport; w-screen/h-screen would be 100vw/vh,
        // which include the scrollbar and cause a sliver of horizontal page scroll.
        "fixed z-40 inset-0 bg-black transition-opacity duration-300 ease-in-out transform",
        props.noBackdrop ? "hidden" : "",
        props.isOpen ? "opacity-10" : "opacity-0 pointer-events-none",
        props.backdropClassName
    );
    const panelClasses = twMerge(
        props.className, // these go first so they can't be overridden
        "-bottom-4 left-0 right-0", // top margin on mobile, attached below the bottom to hide the bottom rounded corners
        "md:bottom-3 md:left-auto md:right-3 md:w-1/2 lg:w-[500px]", // attached to the right side of the screen on desktop
        "top-14 fixed z-50 bg-white rounded-xl shadow-lg",
        "transition-transform duration-300 ease-in-out transform", // controls animation in and out
        props.isOpen ? "translate-y-0 md:translate-x-0" : "translate-y-[110%] md:translate-x-[110%] md:translate-y-0 pointer-events-none", // visibility is done by just undoing the translate
    );
    return (
        <div className="relative">
            {/* Dim the background when we're visible and noOverlay isn't true */}
            <div onClick={props.shouldClose ? props.shouldClose : () => {}} className={backdropClasses} />
            <div className={panelClasses}>
                {props.children}
            </div>
        </div>
    );
}